var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationMainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.576 130.652c-33.731 0-61.076-27.344-61.076-61.076C8.5 35.845 35.845 8.5 69.576 8.5c33.732 0 61.076 27.345 61.076 61.076 0 33.732-27.344 61.076-61.076 61.076ZM.5 69.576c0 38.15 30.927 69.076 69.076 69.076 38.15 0 69.076-30.926 69.076-69.076C138.652 31.426 107.726.5 69.576.5 31.426.5.5 31.427.5 69.576Zm69.076 30.03a4 4 0 0 0 4-4v-26.03a4 4 0 1 0-8 0v26.03a4 4 0 0 0 4 4Zm0-52.06a4 4 0 1 1 0-8h.066a4 4 0 1 1 0 8h-.066Z",
    fill: "#88898D",
    fillOpacity: 0.19
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMainIcon);
export default __webpack_public_path__ + "static/media/notification-main-icon.b43385287052ea099c1955bd0720e1c4.svg";
export { ForwardRef as ReactComponent };